const { loginUrl, logoutUrl, refreshUrl, newPasswordUrl } = require("../../../shared/constants/apiUrls");
const { baseApi } = require("./baseApi");

const authApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        login: builder.mutation({
            query: ({ username, password }) => ({
                url: loginUrl,
                method: "POST",
                data: { username, password },
            }),
        }),
        logout: builder.mutation({
            query: () => ({
                url: logoutUrl,
                method: "POST",
            }),
            extraOptions: { private: true },
        }),
        refresh: builder.mutation({
            query: () => ({
                url: refreshUrl,
                method: "POST",
            }),
        }),
        completeNewPassword: builder.mutation({
            query: ({ username, newPassword, session }) => ({
                url: newPasswordUrl,
                method: "POST",
                data: { username, newPassword, session },
            }),
        }),
    }),
});

export const {
    useLoginMutation,
    useLogoutMutation,
    useRefreshMutation,
    useCompleteNewPasswordMutation
} = authApi;
